import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field-transformation-drawer" on the section wrapping
// the transforms card + the drawer. Opens the drawer and lazy-loads the new/edit
// form into its content frame.
//
// Triggers (Add button, per-row Edit links) carry the URL via
// data-field-transformation-drawer-url-param.
export default class extends Controller {
  static targets = ["frame"]
  static values = { identifier: { type: String, default: "field-transformation" } }

  open(event) {
    event.preventDefault()
    const url = event.params.url
    if (url && this.hasFrameTarget) {
      if (this.frameTarget.getAttribute("src") === url) {
        this.frameTarget.reload()
      } else {
        this.frameTarget.setAttribute("src", url)
      }
    }
    // drawer-instance listens for drawer:open@window and matches by element id.
    window.dispatchEvent(new CustomEvent("drawer:open", { detail: { instance: this.identifierValue } }))
  }

  // The type picker (a GET form targeting the frame) re-loads the drawer body for
  // the chosen transform type.
  submitType(event) {
    event.target.form?.requestSubmit()
  }
}
